import { render, staticRenderFns } from "./SortListMyGames.vue?vue&type=template&id=c092a48a"
import script from "./SortListMyGames.vue?vue&type=script&lang=js"
export * from "./SortListMyGames.vue?vue&type=script&lang=js"
import style0 from "./SortListMyGames.vue?vue&type=style&index=0&id=c092a48a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports